/* global modForm Modalytics */
import { showStep } from '../../../helpers';
/**
 * Show first step with error
 */
export function showStepWithFirstError() {
	const $errors = modForm.opts.form.querySelectorAll('.' + modForm.opts.fieldErrorCls);

	if ($errors.length) {
		const $firstStepWithError = $errors[0].parentElement.closest(modForm.opts.stepsSelector),
			firstStepID = $firstStepWithError.getAttribute('id'),
			firstErrorName = $errors[0].querySelector('input').getAttribute('name');

		if ($firstStepWithError) {
			showStep(firstStepID);
			Modalytics.heap('track', [
				'Step Shown with Validation API Error | ' + firstStepID + ' ' + firstErrorName,
				{}
			]);
		}
	}
}
